
import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import TooltipLabel from "@/components/general/TooltipLabel.vue";
import TooltipIcon from "@/components/general/TooltipIcon.vue";
import DateFormatter from "@/mixins/dateFormatterMixin";
import { PercentIndicator } from "@/mixins/percentIndicatorMixin";
import TradeModel from "@/models/Trade";
import OpenOrder from "@/models/OpenOrder";
import { sortItems } from "@/utils/sortingUtils";
import SensitiveNumbersMixin from "@/mixins/sensitiveNumbersMixin";
import DownloadTradeLog from "./DownloadTradeLog.vue";
import Formatter from "@/mixins/formatterMixin";

@Component({
  components: { TooltipLabel, TooltipIcon, DownloadTradeLog },
  mixins: [PercentIndicator, DateFormatter, SensitiveNumbersMixin, Formatter],
})
export default class BotsActivityTable extends Vue {
  // 📦 Headers used for the open orders table
  @Prop()
  public openOrdersHeaders!: any[];

  // 📦 All open orders the bots have
  @Prop({ default: [] })
  public openOrders?: OpenOrder[];

  // 📦 Headers used for the trade history table
  @Prop()
  public tradeHistoryHeaders!: any[];

  // 📦 All the trades the active bots have conducted
  @Prop({ default: [] })
  public tradeHistory!: TradeModel[];

  // 🚩 Flag for whether the table is loading
  @Prop({ default: false })
  public loading!: boolean;

  // 🚩 Flag for whether the open orders section should be disabled
  @Prop({ default: false })
  public disableOpenOrders!: boolean;

  // 📦 Holds the currently selected tab (trade history by default)
  private selectedTab: number = 1;

  // 📦 Pagination object used for default sorting the trade log
  private paginationTradeLog = {
    sortBy: ["date"],
    sortDesc: [false],
    mustSort: true,
    itemsPerPage: 10,
  };

  // 📦 Pagination object used for default sorting the open orders
  private paginationOpenOrders = {
    sortBy: ["createTime"],
    sortDesc: [false],
    mustSort: true,
    itemsPerPage: 10,
  };

  // 📦 The footer props of the data tables
  private footerProps: any = {
    "items-per-page-options": [10, 25, 50, -1],
  };

  // 🌍 The base URL of the website
  private get baseURL(): string {
    return window.location.origin;
  }

  /**
   * 📋 Custom sorting function that orders the trades by date
   */
  private sortByDate(items: any[], index: string[], isDesc: boolean[]) {
    return sortItems("date", items, index, isDesc);
  }

  /**
   * 📋 Custom sorting function that orders the trades by date
   */
  private sortByCreateTime(items: any[], index: string[], isDesc: boolean[]) {
    return sortItems("createTime", items, index, isDesc);
  }

  /**
   * 🎨 Sets the color of a trade line based on the type
   */
  private getTypeColor(type: string) {
    if (type == "BUY") return "green--text font-weight-bold";
    if (type == "SELL") return "red--text font-weight-bold";
  }
}
